export const zh = {
    Upload: "上传",
    ClickToUpload: "点击或拖拽文件至该区域"
}